import { Alert, Button } from "antd";
import LineSpacer from "../../../../../../../components/LineSpacer";
import { PlusOutlined } from "@ant-design/icons";
import { WplywContext } from "../../../../../../../context/wplywContext";
import { useContext } from "react";
import ReckoningsTransfers from "./ReckoningTransfers";
import numberFormat from "../../../../../../../components/numberFormat";
import InitReserve from "./InitReserve";
import Transfer from "../InnerStage2/Transfer";
import { useAuth } from "../../../../../../../context/AuthContext";
import ProgressBarTransfers from "./ProgressBarTransfers";
import formatPrice from "../../../../../../../components/formatPrice";

const InnerStage2 = (props) => {
	const { selectedPerson } = props;
	const { wplyw, setWplyw } = useContext(WplywContext);
	const isGeneratedTransferLocked =
		Boolean(selectedPerson?.msr_persons_transfers_generated_file) ||
		Boolean(selectedPerson?.msr_reserves_generated_file) ||
		Boolean(
			(selectedPerson?.msr_transfers || []).some(
				(t) => t?.msr_transfers_generated_file
			)
		) ||
		Boolean(
			(selectedPerson?.msr_reckonings || []).some((r) =>
				(r?.msr_transfers || []).some(
					(t) => t?.msr_transfers_generated_file
				)
			)
		);
	const isDisabled = wplyw.mode === "preview" || isGeneratedTransferLocked;
	const { user } = useAuth();
	const total = selectedPerson.msr_reckonings.reduce(
		(reck_sum, reck) =>
			reck_sum +
			(parseFloat(reck.msr_reckonings_part_amount) -
				parseFloat(reck.msr_reckonings_deduction_from_income)) -
			reck.msr_deductions.reduce(
				(sum2, reckded) =>
					sum2 + parseFloat(reckded.msr_deductions_amount),
				0
			),
		0
	);

	const handleAddTransfer = () => {
		if (isDisabled) {
			return;
		}
		const newTransfer = {
			msr_transfers_id: `temp_${Date.now()}`,
			msr_transfers_create_datetime: new Date().toISOString(),
			msr_transfers_own_id: Math.floor(new Date().getTime() / 1000),
			msr_transfers_amount:
				total -
				(selectedPerson?.msr_reserves_amount || 0) -
				selectedPerson.msr_transfers.reduce(
					(sum, tr) => sum + parseFloat(tr.msr_transfers_amount),
					0
				),
			msr_transfers_account_number: "",
			msr_transfers_account_owner: "",
			msr_transfers_title_suffix: "",
			msr_transfers_types_id:
				wplyw?.wplyw_data?.data?.default_values?.msr_transfers_types[0]
					?.msr_transfers_types_id || null,
		};

		setWplyw((prev) => {
			// Update person's transfers
			const updatedPersons =
				prev.wplyw_data.data.msr_wplywy.msr_persons.map((person) =>
					person.msr_persons_id === selectedPerson.msr_persons_id
						? {
								...person,
								msr_transfers: [
									...(person.msr_transfers || []),
									newTransfer,
								], // Add the new transfer
						  }
						: person
				);

			// Manage changes array
			const changes = [...(prev.changes || [])];
			const existingChangeIndex = changes.findIndex(
				(change) =>
					change.field === "msr_transfers" &&
					change.objectid === newTransfer.msr_transfers_own_id
			);

			if (existingChangeIndex > -1) {
				// Update existing log
				changes[existingChangeIndex] = {
					...changes[existingChangeIndex],
					newValue: `Zaktualizowano przelew o ID ${newTransfer.msr_transfers_own_id}`,
					datetime: Math.floor(new Date().getTime() / 1000),
				};
			} else {
				// Add new log
				changes.push({
					etap: "Przelewy",
					field: "msr_transfers",
					label: "Dodano przelew",
					action: "add",
					oldValue: null,
					newValue: `Dodano nowy przelew o ID ${newTransfer.msr_transfers_own_id}`,
					datetime: Math.floor(new Date().getTime() / 1000),
					user: user.user.mlg_users_id,
					objectid: newTransfer.msr_transfers_own_id,
					wplywid: prev.wplyw_data.data.msr_wplywy.msr_wplywy_own_id,
					personid: selectedPerson.msr_persons_own_id,
				});
			}

			return {
				...prev,
				wplyw_data: {
					...prev.wplyw_data,
					data: {
						...prev.wplyw_data.data,
						msr_wplywy: {
							...prev.wplyw_data.data.msr_wplywy,
							msr_persons: updatedPersons,
						},
					},
				},
				changes, // Update the changes array
			};
		});
	};

	return (
		<>
			{isGeneratedTransferLocked ? (
				<>
					<Alert
						message="Edycja zablokowana"
						description="Nie można edytować etapu 'Rachunki', ponieważ przelewy dla tej osoby zostały już wygenerowane."
						type="success"
						showIcon
						style={{ marginBottom: 16 }}
					/>
				</>
			) : null}
			{selectedPerson && (
				<div
					style={{
						padding: "16px",
						borderRadius: "8px",
						marginTop: "16px",
						background: "white",
						color: "black",
						border: "2px solid #BD8136",
						display: "grid",
						gridTemplateColumns: "repeat(4, 1fr)",
						gap: "20px",
					}}
				>
					<div>
						<div>Imię i nazwisko</div>
						<div
							style={{
								fontSize: "16px",
								marginTop: "8px",
								fontWeight: "700",
							}}
						>
							{selectedPerson?.msr_persons_name || "Brak danych"}{" "}
							{selectedPerson?.msr_persons_lastname || ""}
						</div>
					</div>
					<div>
						<div>Kwota do przelewu</div>
						<div
							style={{
								fontSize: "16px",
								marginTop: "8px",
								fontWeight: "700",
							}}
						>
							{formatPrice(total || 0)} zł
						</div>
					</div>
					<div>
						<div>Kwota rezerwy</div>
						<div
							style={{
								fontSize: "16px",
								marginTop: "8px",
								fontWeight: "700",
							}}
						>
							{formatPrice(
								parseFloat(
									selectedPerson?.msr_reserves_amount
								) || 0
							)}{" "}
							zł
						</div>
					</div>
					<div>
						<div>Ostateczna kwota do przelewów</div>
						<div
							style={{
								fontSize: "16px",
								marginTop: "8px",
								fontWeight: "700",
							}}
						>
							{formatPrice(
								(total || 0) -
									(selectedPerson?.msr_reserves_amount || 0)
							)}{" "}
							zł
						</div>
					</div>
				</div>
			)}
			<ProgressBarTransfers
				selectedPerson={selectedPerson}
			></ProgressBarTransfers>
			<InitReserve
				selectedPerson={selectedPerson}
				total={total}
			></InitReserve>
			<div
				style={{
					display: "flex",
					gap: "20px",
					alignItems: "center",
					margin: "20px 0",
				}}
			>
				<div
					style={{
						background: "white",
						color: "black",
						padding: "7px 15px",
						fontSize: "18px",
						borderRadius: "5px",
					}}
				>
					Przelewy
				</div>
				<LineSpacer />
				{!isDisabled && (
					<Button
						disabled={
							parseFloat(
								total -
									(selectedPerson.msr_reserves_amount || 0) -
									selectedPerson.msr_transfers.reduce(
										(sum, tr) =>
											sum +
											parseFloat(tr.msr_transfers_amount),
										0
									)
							) <= 0
						}
						onClick={handleAddTransfer}
					>
						Dodaj wypłatę{" "}
						{parseFloat(
							total -
								(selectedPerson.msr_reserves_amount || 0) -
								selectedPerson.msr_transfers.reduce(
									(sum, tr) =>
										sum +
										parseFloat(tr.msr_transfers_amount),
									0
								)
						) <= 0
							? " - WYKORZYSTANO LIMIT"
							: ""}
					</Button>
				)}
			</div>
			{selectedPerson.msr_transfers.map((transfer, i) => (
				<Transfer
					total={total}
					key={transfer.msr_transfers_id}
					index={i}
					transfer={transfer}
					selectedPerson={selectedPerson}
				/>
			))}
		</>
	);
};

export default InnerStage2;
